webpackJsonp([29102153025240],{

/***/ 374:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"BannerLink":"src-components-BannerLink----BannerLink-module---BannerLink---2_9Y5","ReducedBannerLink":"src-components-BannerLink----BannerLink-module---ReducedBannerLink---23mYG","Button":"src-components-BannerLink----BannerLink-module---Button---1OSVf"};

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _marked = __webpack_require__(11);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _BannerLinkModule = __webpack_require__(374);
	
	var _BannerLinkModule2 = _interopRequireDefault(_BannerLinkModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerLink = function BannerLink(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: props.reducedPadding ? _BannerLinkModule2.default.ReducedBannerLink : _BannerLinkModule2.default.BannerLink },
	    _react2.default.createElement(
	      'h2',
	      { className: 'h2', style: props.alignCenter ? { textAlign: 'center' } : {} },
	      props.title
	    ),
	    props.content && _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(props.content) }, style: props.alignCenter ? { textAlign: 'center' } : {} }),
	    _react2.default.createElement(
	      'a',
	      { href: props.link, className: _BannerLinkModule2.default.Button },
	      props.linkText
	    )
	  );
	};
	
	exports.default = BannerLink;
	module.exports = exports['default'];

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"BannerImage":"src-components-ForParents-BannerImage----BannerImage-module---BannerImage---2PSfy"};

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BannerImageModule = __webpack_require__(167);
	
	var _BannerImageModule2 = _interopRequireDefault(_BannerImageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerImage = function BannerImage(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _BannerImageModule2.default.BannerImage, id: props.identifier },
	    _react2.default.createElement('img', { src: props.image, alt: '' }),
	    props.title && _react2.default.createElement(
	      'p',
	      null,
	      props.title
	    )
	  );
	};
	
	exports.default = BannerImage;
	module.exports = exports['default'];

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(29);
	
	var _BannerLink = __webpack_require__(336);
	
	var _BannerLink2 = _interopRequireDefault(_BannerLink);
	
	var _BannerImage = __webpack_require__(154);
	
	var _BannerImage2 = _interopRequireDefault(_BannerImage);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Fellows = __webpack_require__(25);
	
	var _Fellows2 = _interopRequireDefault(_Fellows);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _Hero = __webpack_require__(9);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Button = __webpack_require__(15);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _KeyStats = __webpack_require__(128);
	
	var _KeyStats2 = _interopRequireDefault(_KeyStats);
	
	var _scroller = __webpack_require__(71);
	
	var _scroller2 = _interopRequireDefault(_scroller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForEducators = function (_React$Component) {
	    _inherits(ForEducators, _React$Component);
	
	    function ForEducators() {
	        _classCallCheck(this, ForEducators);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    ForEducators.prototype.componentDidMount = function componentDidMount() {
	        var ScrollReveal = __webpack_require__(149);
	
	        window.setTimeout(function () {
	            window.sr = ScrollReveal();
	            sr.reveal('.keystat', { duration: 600, delay: 200 }, 80);
	            sr.reveal('.block', { duration: 600, delay: 200 }, 80);
	            sr.reveal('.teacher-block', { duration: 600, delay: 250 }, 80);
	        }, 200);
	    };
	
	    ForEducators.prototype.scrollPageTo = function scrollPageTo(el) {
	        var element = document.querySelector(el);
	        scrollTo(document.documentElement, element.offsetTop, 500);
	    };
	
	    ForEducators.prototype.render = function render() {
	        var data = {
	            seo: {
	                pageTitle: 'For Educators | Global Citizen Year'
	            }
	            // const fellows = this.props.data.fellows
	
	            // <div className="iframe-container">
	            //     <iframe width="100%"
	            //         height="537"
	            //         src="https://www.youtube.com/embed/0ZBd01te7ag?rel=0&amp;controls=0&amp;showinfo=0"
	            //         frameBorder="0"
	            //         allowFullScreen />
	            // </div>
	
	        };return _react2.default.createElement(
	            'div',
	            { className: 'page-ambassador page-single' },
	            _react2.default.createElement(_CustomHelmet2.default, { data: data.seo }),
	            _react2.default.createElement(_Hero2.default, { title: 'PREPARING THE NEXT GENERATION OF LEADERS TO MOVE THE WORLD AHEAD' }),
	            _react2.default.createElement(
	                _Row2.default,
	                { className: 'no-top-padding' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'capper' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Global Citizen Year is a nonprofit pioneering a model that wraps curriculum and coaching around real-world experience to transform the trajectory of our most promising young leaders.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Global Citizen Year offers two distinct programs:'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'h3' },
	                        'The Academy'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Launched in 2020 in response to the COVID pandemic, Global Citizen Academy is an intensive leadership experience equipping students aged 17-21 with powerful and practical skills for a lifetime of social impact. Centered around our signature pedagogy, Leadership as a Practice, Academy students, engage in a blend of coursework, experiential learning, workshops with leading innovators, and collaboration with peers from around the world. With a ~5-7 hour/week commitment, the Academy is designed to be paired with and add value to whatever else your student is doing (high school, college, internship, job, or anything else!).'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'h3' },
	                        'The Fellowship'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Each year Global Citizen Year recruits talented high school graduates from across the country and around the world. For the equivalent of an academic year, Global Citizen Year Fellows live with a host family in a community in Africa, Latin America or Asia and apprentice to local efforts advancing education, health and sustainability. By staying longer and going deeper, Global Citizen Year Fellows develop insights that shape their character, guide their higher education and equip them to make a meaningful impact over the course of their lives.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _Row2.default,
	                { id: 'join-us', className: 'bg-grey' },
	                _react2.default.createElement('img', { className: 'Hero__strokes', src: '/images/green-strokes.png', alt: 'green strokes' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'capper' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'h2' },
	                        'We need your help.'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'block' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'h3' },
	                            'Join our Nominator Program!'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Join a growing network of over 700 educators across the globe who are helping us identify exceptional students for our unique leadership programs.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Becoming a Nominator will give you the opportunity to nominate your students for an experience they can\u2019t find anywhere else. By joining, we\u2019ll keep you informed about application deadlines, special scholarships and events. All nominations are completely non-binding and there\u2019s no requirement to nominate.'
	                        ),
	                        _react2.default.createElement(_Button2.default, { text: 'Join our Nominator Program', href: '/nominator/' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'block' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'h3' },
	                            'Already a member of the Global Citizen Year Nominator Program?'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Share our unique leadership programs with a student! ',
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'The nomination is completely non-binding'
	                            ),
	                            ' - it\'s completely up to the student whether they choose to apply and, if accepted, whether they decide to enroll in the program. Once you nominate a student, we\'ll follow up to share more information about our programs and help them figure out if Global Citizen Year is a good fit for them!'
	                        ),
	                        _react2.default.createElement(_Button2.default, { text: 'Nominate a Student', href: '/nominate-a-student/' }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null)
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _Row2.default,
	                { className: 'no-padding-bottom' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'capper' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'block' },
	                        _react2.default.createElement(
	                            'h2',
	                            { className: 'h2' },
	                            'OUR COMMITMENT TO DIVERSITY, EQUITY, AND ACCESS'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'As a non-profit committed to advancing equity and opportunity for all, we are dedicated to making this experience available to the highest potential young leaders we can find, independent of their family\u2019s financial circumstance.'
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'h3' },
	                            'The Academy'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'We are pleased to offer a sliding scale model for the Academy from $500-$7500. We ask students to pay at the highest level of the sliding scale that they can afford. This allows others who need to pay less the opportunity to attend.'
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'h3' },
	                            'The Fellowship'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Global Citizen Year awards is proud to offer a need-blind admissions process for its Fellowship. We offer both merit and need-based gap year scholarships, and are committed to making this experience accessible. The full fellowship tuition is $32,500. To date, 80% of our Fellows have received a partial scholarship, and 30% of those have received a full ride. We will work closely with students and their family to understand their financial need before determining their financial aid package.'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _Row2.default,
	                { className: 'teacher-section capper' },
	                _react2.default.createElement(
	                    _Column2.default,
	                    { width: '10' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'h2' },
	                        'Hear from our supporters'
	                    )
	                ),
	                _react2.default.createElement(
	                    _Column2.default,
	                    { className: 'teacher-block', width: '12' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', { src: 'https://images.ctfassets.net/j91b9gwu8s3q/6a3jT9TrEN7PqvNwWg6Q9f/6e5710298225edef8574c38c5dff23d1/Rebecca_Warren_headshot.png', alt: 'Rebecca Warren, Head of Educational Development UWC International' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'h3' },
	                            'Rebecca Warren, Head of Educational Development UWC International'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '"Many students from UWC (United World Colleges) choose Global Citizen Year as an aligned and enriching next step before college. Coming from all around the world, the attention to equity is really important to our students and to our organization, and we appreciate the care that GCY takes in preparing and mentoring young people as learners within meaningful placements. We witness tangible growth in maturity and their ability to face challenges. Perhaps, more importantly, we see our students acquire a deep place-based understanding of both local and global sustainability issues, guided by GCY, through their reflections on the relationships they develop and the experiences they have."'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Column2.default,
	                    { className: 'teacher-block', width: '12' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', { src: '/images/Eric-Lombardi.jpg', alt: 'Eric Lombardi, Head of Fort Worth County Day School' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'h3' },
	                            'Eric Lombardi, Head of Fort Worth County Day School'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '"As a school proud of sending 100% of our graduates to college, we are also thrilled to have Global Citizen Year as an option we present to those students who know that they need something different and who want to make a difference in that year after they graduate. We were particularly pleased to find their commitment to scholarship dollars. In our search for the best options for our graduates, Global Citizen Year quickly went to the top of the list."'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Column2.default,
	                    { className: 'teacher-block', width: '12' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', { src: '/images/Rick-Shaw.jpg', alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'h3' },
	                            'Rick Shaw, Stanford University Dean of Admissions'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '"We find the kids who come back from a year off are often wiser, they\'re more mature, and have a different perspective than those who might have gone straight to college."'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Column2.default,
	                    { className: 'teacher-block', width: '12' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', { src: '/images/headshots/Ivy-Shamis.jpg', alt: 'Ivy Shamis, Marjory Stoneman Douglas Teacher' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'h3' },
	                            'Ivy Shamis, Marjory Stoneman Douglas Teacher'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            '\u201CSeveral of our students are taking advantage of being immersed in an global gap year before college and they are making the memories of a lifetime. These students experience being part of a global community, leading to interconnected world leadership that will shape their values, beliefs and perspectives. This program gives them insight to how the world cooperates and a sense of responsibility to help keep our world free from hate, conflicts, poverty and pollution and instead filled with diversity, equality, opportunity and love.\u201D'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'banner-wrap' },
	                _react2.default.createElement(_BannerImage2.default, { image: 'http://images.ctfassets.net/j91b9gwu8s3q/2VfxZemqXu2GOMuC8miO0A/feaf2238c5cfe2198c747c7fe7d34020/17010879972_f3d89a0c0a_k.jpg',
	                    title: 'Alcyone Magana, Ecuador 15,Watson University' })
	            ),
	            _react2.default.createElement(
	                _Row2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'capper' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'h2' },
	                        'Student outcomes & our impact'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Since 2010, we have trained more nearly 1,000 emerging leaders from 46 states and 32 countries, and applications to our program are doubling each year.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        'Global Citizen Year alumni are highly engaged in their education because they are connected to their purpose. They are going to college with the perspectives, skills and mindsets that enable them to make the most of their undergraduate experience.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        'Upon graduation, they are finding meaningful careers that directly align with the personal mission they discovered on their Global Citizen Year.'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://assets.ctfassets.net/j91b9gwu8s3q/32J3zMCSMMQys86qYmwq0I/f0bc607da92cf71f5adefce77de81b64/Global_Citizen_Year_Alumni_Outcomes_Report.pdf', target: '_blank', className: 'hoverlink' },
	                        'View our Alumni outcomes Report'
	                    )
	                )
	            ),
	            _react2.default.createElement(_KeyStats2.default, {
	                keystats: [{
	                    title: "91% become proficient in a new language",
	                    text: { text: "The vast majority of Fellows placed in Brazil, Senegal, and Ecuador return proficient in a new language." }
	                }, {
	                    title: "Tesla, JP Morgan, United Nations, TFA",
	                    text: { text: "After college, alumni are finding meaningful work with cross-sector organizations and 85% believe their work makes a difference in the lives of others." }
	                }, {
	                    title: "Graduate college one year faster",
	                    text: { text: "Our alumni are graduating from college one year faster than the national average." }
	                }, {
	                    title: "Fulbright, Rhodes & Gates Scholars",
	                    text: { text: "Distinguished by their Global Citizen Year, alumni achieve competitive grants and fellowships." }
	                }]
	            }),
	            _react2.default.createElement(
	                'div',
	                { className: 'apply-wrap' },
	                _react2.default.createElement(_BannerLink2.default, {
	                    title: 'JOIN OUR NOMINATOR PROGRAM',
	                    linkText: 'Become a Nominator',
	                    link: '/nominator/'
	                })
	            )
	        );
	    };
	
	    return ForEducators;
	}(_react2.default.Component);
	
	exports.default = ForEducators;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-for-educators-js-b65c45d593721e2da4f6.js